<table class="container">
  <thead class="top-container">
    <tr>
      <th class="email">
        <span class="material-symbols-outlined"> email</span>
      {{ soa.emailId }}</th>
      <th class="heading email-sent">Email Sent</th>
      <th class="heading link-clicked" [ngStyle]="{'backgroundColor':getHeadingColor(linkClicked?.length > 0)}">Link
        Clicked
      </th>
      <th class="heading customer-valid" [ngStyle]="{'backgroundColor':getHeadingColor(customerAction?.length > 0)}">
        Customer Valid
      </th>
      <th class="heading completed" [ngStyle]="{'backgroundColor':getHeadingColor(agentAction?.length > 0)}">Completed
      </th>
      <th class="heading archived" [ngStyle]="{'backgroundColor':getArchivedHeaderColor()}">Archived</th>
    </tr>
  </thead>
  <tr class="bottom-container">
    <td class="user-details-container">
      <div class="user-detail soa-id">
        <div class="soa-container">
          <div class="user-data-label">SOA ID:</div>
          <span class="soa-id">{{ soa.soaTokenId }}</span></div>
          @if (showLinkToAgentEsoa) {
            <div class="agent-esoa-link"><a
          [href]="this.agentEsoaLink + '?ReferralID=' + this.soa.soaTokenId">Go to ESOA_{{ soa.lastName }}</a></div>
}
        @if (showResendSoaLink && !resendLinkLoading) {
<div class="agent-esoa-link"><a href=""
                                                                                        (click)="resendCustomerSoa($event)">Resend
          ESOA to Customer</a></div>
}
        @if (resendLinkLoading) {
<mat-spinner class="agent-esoa-link" [diameter]="25"></mat-spinner>
}
      </div>
      <div class="user-detail name">
        <div class="user-data-label">Name:</div>
        <span class="name">{{ soa.firstName }} {{ soa.lastName }}</span></div>
    </td>
    <td class="soa-detail email-sent">
      {{ soa.emailSent.actionDate | date:'shortDate' }}
        </td>
        <td class="soa-detail link-clicked">
          @if (linkClicked?.length) {
            <div class="date-container link-clicked-date">
              @for (click of soa.linkClicked; track click) {
                <div>
                  {{ click.actionDate  | date:'shortDate' }}
                </div>
              }
            </div>
          }
          @if (!linkClicked?.length) {
            <span class="material-symbols-outlined" aria-label="Launch Icon" aria-hidden="false" title="Launch">launch</span>
          }
        </td>
        <td class="soa-detail customer-valid">
          @if (customerAction?.length) {
            <div class="date-container customer-valid-date">
              @for (action of soa.customerAction; track action) {
                <div>
                  {{ action.actionDate  | date:'shortDate' }}
                </div>
              }
            </div>
          }
          @if (!customerAction?.length) {
            <span class="material-symbols-outlined" aria-label="Empty Hourglass Icon" aria-hidden="false" title="Empty Hourglass">hourglass_empty</span>
          }
        </td>
        <td class="soa-detail completed">
          @if (agentAction?.length) {
            <div class="date-container completed-date">
              @for (action of soa.agentAction; track action) {
                <div>
                  {{ action.actionDate  | date:'shortDate' }}
                </div>
              }
            </div>
          }
          @if (!agentAction?.length) {
            <span class="material-symbols-outlined" aria-label="Pencil Icon" aria-hidden="false" title="Pencil">edit</span>
          }
        </td>
        <td class="soa-detail">
          <span class="material-symbols-outlined" aria-label="Lock Icon" aria-hidden="false" title="Lock">lock</span>
        </td>
      </tr>
    </table>
